import { VALIDATION_STATES } from '../../../core/const/fields.js';

const parseDefaultValue = (value) => {
  if (typeof value === 'number') {
    return value.toString();
  }
  return value;
};

const setTimer = (inputComponent) => {
  inputComponent.stopped = false;
  inputComponent.start = null;
  inputComponent.timer = inputComponent.expirationSeconds;
  inputComponent.totalMilliSeconds = inputComponent.minSeconds * 1000;
  inputComponent.countdown = requestAnimationFrame(inputComponent.updateTimer);
};

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: Number,
      default: 6,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    value: {
      type: [String, Number],
    },
    onChange: {
      type: Function,
      required: true,
    },
    onInstantChange: {
      type: Function,
      required: true,
    },
    defaultText: {
      type: String,
      default: 'Please be patient, it can take some seconds.',
    },
    resendAction: {
      type: String,
      default: 'Resend SMS',
    },
    resendText: {
      type: String,
      default: 'if you did not receive it.',
    },
    expiredText: {
      type: String,
      default: 'OTP expired, please ',
    },
    expirationSeconds: {
      type: Number,
      default: 900,
    },
    resendCode: {
      type: Function,
      default: () => {},
    },
    validatedText: {
      type: String,
      default: 'OTP code successfully validated.',
    },
  },
  data() {
    return {
      isFocused: false,
      internalValue: parseDefaultValue(this.value),
      timer: this.timer,
      progress: this.progress,
      stopped: this.stopped,
    };
  },
  computed: {
    inputType() {
      return (this.type === 'number' || this.type === 'tel') ? 'tel' : 'text';
    },
    hasContent() {
      return !!this.internalValue;
    },
    isActive() {
      return this.isFocused || this.hasContent;
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
    isGenerated() {
      return !this.stopped && !this.isDisabled && !this.isResendable;
    },
    isResendable() {
      // allow 20 seconds before making the resend link visible
      return this.progress >= 20 * 1000 && !this.isDisabled && !this.isExpired;
    },
    isExpired() {
      return this.stopped && !this.isDisabled;
    },
    placeholder() {
      if (String.prototype.repeat) {
        return '0'.repeat(this.maxlength);
      }
      return '0000';
    },
    minSeconds() {
      return Math.min(this.expirationSeconds, 900);
    },
  },
  methods: {
    onChangeHandler(fn) {
      const { type, internalValue, hasContent } = this;

      if (type === 'number') {
        if (hasContent) {
          return fn(Number(internalValue));
        }

        return fn(null);
      }

      return fn(internalValue);
    },

    updateTimer(timer) {
      if (!this.start) {
        this.start = timer;
      }

      this.progress = timer - this.start;
      const left = Math.floor((this.totalMilliSeconds - this.progress) / 1000);
      if (left >= 0 && !this.stopped) {
        this.timer = left;
        this.countdown = requestAnimationFrame(this.updateTimer);
      } else {
        this.stopped = true;
        cancelAnimationFrame(this.countdown);
      }
    },

    async resendHandler() {
      const response = await this.resendCode();
      if (response) {
        setTimer(this);
      }
    },
  },
  mounted() {
    setTimer(this);
  },
  update() {
    this.internalValue = this.value;
  },
};
